import plh1 from "../images/projects/planets-little-helper1.png";
import plh2 from "../images/projects/planets-little-helper2.png";
import plh3 from "../images/projects/planets-little-helper3.png";
import plh4 from "../images/projects/planets-little-helper4.png";
import plh5 from "../images/projects/planets-little-helper5.png";
import plh6 from "../images/projects/planets-little-helper6.png";
import plh7 from "../images/projects/planets-little-helper7.png";
import plh8 from "../images/projects/planets-little-helper8.png";
import plh9 from "../images/projects/planets-little-helper9.png";
import photoHub1 from "../images/projects/ng-photo1.png";
import photoHub2 from "../images/projects/ng-photo2.png";
import photoHub3 from "../images/projects/ng-photo3.png";
import photoHub4 from "../images/projects/ng-photo4.png";
import photoHub5 from "../images/projects/ng-photo5.png";
import photoHub6 from "../images/projects/ng-photo6.png";
import photoHub7 from "../images/projects/ng-photo7.png";
import photoHub8 from "../images/projects/ng-photo8.png";
import photoHub9 from "../images/projects/ng-photo9.png";
import photoHub10 from "../images/projects/ng-photo10.png";
import complainerApp1 from "../images/projects/complainer-app1.png";
import complainerApp2 from "../images/projects/complainer-app2.png";
import complainerApp3 from "../images/projects/complainer-app3.png";
import complainerApp4 from "../images/projects/complainer-app4.png";
import complainerApp5 from "../images/projects/complainer-app5.png";
import wildlifePhoto2 from "../images/projects/wildlife-photo2.png";
import wildlifePhoto3 from "../images/projects/wildlife-photo3.png";
import wildlifePhoto4 from "../images/projects/wildlife-photo4.png";
import wildlifePhoto5 from "../images/projects/wildlife-photo5.png";
import wildlifePhoto6 from "../images/projects/wildlife-photo6.png";
import wildlifePhoto7 from "../images/projects/wildlife-photo7.png";
import portfolio1 from "../images/projects/portfolio1.png";

export type ProjectKey =
  | "planets-little-helper"
  | "photo-hub"
  | "complainer-app"
  | "wildlife-photography"
  | "portfolio";

export interface ProjectInfo {
  title: string;
  thumbnail: string;
  images: string[];
  description: string[];
  githubLink: string;
}

export const data: Record<ProjectKey, ProjectInfo> = {
  "planets-little-helper": {
    title: "Planet's Little Helper",
    thumbnail: plh1,
    images: [plh2, plh3, plh4, plh5, plh6, plh7, plh8, plh9],
    description: [
      "This app was created as the final project for TechLabs Berlin by a dedicated team of six, with me serving as the front-end developer.",
      "The goal was to develop a web app that helps users improve their habits and become more environmentally conscious through simple challenges, empowering anyone to make a positive impact.",
    ],
    githubLink: "https://github.com/TechLabs-Berlin/st21-planets-little-helper",
  },
  "photo-hub": {
    title: "PhotoHub",
    thumbnail: photoHub1,
    images: [
      photoHub2,
      photoHub3,
      photoHub4,
      photoHub5,
      photoHub6,
      photoHub7,
      photoHub8,
      photoHub9,
      photoHub10,
    ],
    description: [
      "PhotoHub is a platform created as a final project for an Angular course. It allows users to browse and upload their photos, offering features such as user profiles, photo galleries, upload functionality, and community interactions through likes. Designed to showcase skills in Angular, PhotoHub provides an engaging space for users to share and explore photographic content.",
    ],
    githubLink: "https://github.com/InaDavidova/ng-photography",
  },
  "complainer-app": {
    title: "Complainer App",
    thumbnail: complainerApp1,
    images: [complainerApp2, complainerApp3, complainerApp4, complainerApp5],
    description: [
      "Complainer App is a full-stack MERN application developed during a 3-day coding challenge. The platform enables users to raise complaints about faulty or damaged laptops, providing a streamlined process for submitting detailed reports.",
    ],
    githubLink: "https://github.com/InaDavidova/complainer-app-MERN",
  },
  "wildlife-photography": {
    title: "Wildlife photography",
    thumbnail: wildlifePhoto2,
    images: [
      wildlifePhoto2,
      wildlifePhoto3,
      wildlifePhoto4,
      wildlifePhoto5,
      wildlifePhoto6,
      wildlifePhoto7,
    ],
    description: [
      "This backend application, built with Express.js, Handlebars, and Mongoose, allows users to browse and upload photos of wildlife along with relevant information. Created for practice as part of my educational journey, it enables users to create, edit, and delete posts. The application showcases the integration of these technologies to manage and display wildlife photography content effectively.",
    ],
    githubLink:
      "https://github.com/InaDavidova/js-backend-wildlife-photography",
  },
  portfolio: {
    title: "This Portfolio",
    thumbnail: portfolio1,
    images: [portfolio1],
    description: [
      "Thank you for visiting my portfolio! ",
      "Of course, this site is also a project that showcases some of my skills, and I had a lot of fun creating it. If you have any tips, suggestions, or bug reports, please feel free to use the contact form below. I appreciate your feedback!",
    ],
    githubLink: "https://github.com/InaDavidova/portfolio",
  },
};
